































































































































import Vue from 'vue'
import Footer from '@/components/Footer.vue'; 
import Header from '@/components/Header.vue'; // @ is an alias to /src
import Rtc from '@/rtc'; 
import SearchResultModal from "@/components/SearchResultModal.vue";
import io from 'socket.io-client';
import axios from 'axios';  


export default  {
  props: {
    source: String
  },
  components: {
    Header,
    Footer,
    SearchResultModal
  },
  data () {
    return {
      drawer: false,
      socket: null,
      search: null
    }
  },
  mounted() {

    if (localStorage.getItem("lang")) {
      this.$i18n.locale = localStorage.getItem("lang");
      this.$store.state.lang = this.$i18n.locale
      axios.defaults.headers.common['x-lang'] = this.$store.state.lang
    }

    if (Vue.config.productionTip) {
      console.log(`  #####       #####  
  #     #     #     # 
  #     #           # 
  #####       #####  
  #     # ### #       
  #     # ### #       
  #####  ### ####### Inspect - 2024`)
    }

    const ref = this
 
    /*
    this.socket.on('connect', function(){
      console.log('SOCKET === connect ', this.id)
      //this.socket.emit
      //this.emit('JOIN_ROOM', { user_id: ref.$store.state.userId })
    });
    
    this.socket.on('MESSAGE', function(data){
      console.log('MESSAGE ===', data)
    });

    */

    window.addEventListener('keyup', function(event) {
      if (event.keyCode == 16) {
        ref.$store.state.key_shift = false
      }
    });

    window.addEventListener('keydown', function(event) {
      if (event.keyCode == 16) {
        ref.$store.state.key_shift = true
      }
    });
/*
  accountSetup()
    .then(resp => {
      if (resp.status == "success") {
        console.log(this.$socket.id)
        this.$store.state.userId = resp.data.userId
        this.$socket.emit('join-room', { user_id: this.$store.state.userId, socket_id: )
      }
    })
    .catch(e => {
      this.$store.dispatch("api_error", e);
      });
*/

 
 /*
    if (this.$store.getters.isLoggedIn) {
      this.socket = io(Vue.prototype.$socketBase)
      this.socket.on('connect', function(){
        console.log('SOCKET =========== connect ')
      });

     this.socket.on('user-connected', function(data){
        console.log('SOCKET =========== user-connected', data)
      });
      
      this.socket.on('event', function(data){
        console.log('SOCKET =========== event', data)
      });
      this.socket.on('disconnect', function(){
        console.log('SOCKET =========== disconnect')
      });
    } 
*/

  },
  methods: {
    globalSearch: function() {
      this.$store.state.search_drawer = !this.$store.state.search_drawer
    },
    logout: function () {
      this.$router.push({ name: 'logout' })
    },    
    inspectCompact: function () {
      this.$router.push({ name: 'inspect_compact' })
    },   
    goOverview: function () {
      this.$router.push({ name: 'overview' })
    },   
    goChecklist: function () {
      this.$router.push({ name: 'checklists' })
    }, 
    goMachineList: function () {
      this.$router.push({ name: 'machines-list' })
    },  
    goMessageFormats: function () {
      this.$router.push({ name: 'message-formats' })
    }, 
    goMachineGroups: function () {
      this.$router.push({ name: 'machines' })
    },  
    goMachineGroupsCompany: function () {
      this.$router.push({ name: 'machines-company' })
    },  
    goInspections: function () {
      this.$router.push({ name: 'inspections' })
    }, 
    goUpdates: function () {
      this.$router.push({ name: 'updates' })
    }, 
    goProject: function () {
      this.$router.push({ name: 'project' })
    }, 
    goFinalize: function () {
      this.$router.push({ name: 'cancelfinalization' })
    },
    goBilling: function () {
      this.$router.push({ name: 'billing' })
    }, 
    goUser: function () {
      this.$router.push({ name: 'users' })
    },
    dialogClosed: function (val) {
      this.showSearchResult = false
    },
  },
  computed: {
    searchField: function() {
      return this.$store.state.searchField;  
    },
    headerT: function () {
      return this.$store.state.headerTitle;  
    },
    userRole: function() {
      if (this.$store.getters.userRole) {
        return this.$store.getters.userRole
      }
      return {}
    }
  },
  created() {
    console.log("--- ",  this.$store.getters.companyId)
  }

}
